import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dealer-invoice-list-page" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "action-bar" }
const _hoisted_4 = { class: "batch-actions" }
const _hoisted_5 = { class: "table-wrapper" }
const _hoisted_6 = { class: "vxe-table-container" }
const _hoisted_7 = { class: "action-links" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "pagination-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_ReloadOutlined = _resolveComponent("ReloadOutlined")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_OioTag = _resolveComponent("OioTag")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_OioPagination = _resolveComponent("OioPagination")!
  const _component_BillingBillDetailPage = _resolveComponent("BillingBillDetailPage")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_IndependentBillingCreatePage = _resolveComponent("IndependentBillingCreatePage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oio_form, {
        layout: "inline",
        data: _ctx.searchForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_oio_form_item, { label: "独立开票包编码" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.code,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.code) = $event)),
                placeholder: "请输入独立开票包编码",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "经销商名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.distributorName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.distributorName) = $event)),
                placeholder: "请输入经销商名称",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "ERP客户编码" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.searchForm.distributorErpCodes,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.distributorErpCodes) = $event)),
                mode: "tags",
                placeholder: "支持批量输入/粘贴",
                "allow-clear": "",
                style: {"width":"220px"},
                class: "single-line-select",
                "token-separators": [',', '，', ' ', '\n'],
                open: false,
                "suffix-icon": null
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "销售机构编码" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.salesOrgCode,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.salesOrgCode) = $event)),
                placeholder: "请输入销售机构编码",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "销售机构名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.salesOrgName,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.salesOrgName) = $event)),
                placeholder: "请输入销售机构名称",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "开票状态" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.searchForm.statusList,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.statusList) = $event)),
                mode: "multiple",
                placeholder: "请选择",
                "allow-clear": "",
                style: {"width":"200px"},
                class: "oio-select single-line-select",
                "dropdown-class-name": "oio-select-dropdown",
                options: _ctx.statusOptions
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "创建人" }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_input, {
                value: _ctx.searchForm.createUserName,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchForm.createUserName) = $event)),
                placeholder: "请输入创建人",
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, { label: "创建时间" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: _ctx.searchForm.dateRange,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchForm.dateRange) = $event)),
                placeholder: ['开始日期', '结束日期']
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_oio_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_oio_button, {
                type: "primary",
                onClick: _ctx.handleSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查询")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_oio_button, {
                style: {"margin-left":"8px"},
                onClick: _ctx.handleReset
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isDistributor)
          ? (_openBlock(), _createBlock(_component_oio_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.handleCreate
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增独立开票")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_oio_button, {
          onClick: _ctx.fetchData,
          loading: _ctx.loading
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_ReloadOutlined)
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 刷新 ")
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_vxe_table, {
          ref: "tableRef",
          border: "",
          "column-config": { resizable: true },
          height: "auto",
          size: "small",
          "show-overflow": "",
          "show-header-overflow": "",
          data: _ctx.tableData,
          loading: _ctx.loading,
          "scroll-x": { enabled: true },
          "scroll-y": { enabled: true, gt: 0 },
          "tooltip-config": { enterable: true },
          "row-config": { isCurrent: true, isHover: true }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_column, {
              field: "code",
              title: "独立开票包编码",
              width: "190",
              fixed: "left"
            }),
            _createVNode(_component_vxe_column, {
              field: "distributorName",
              title: "经销商名称",
              width: "180"
            }),
            _createVNode(_component_vxe_column, {
              field: "distributorErpCode",
              title: "ERP客户编码",
              width: "120"
            }),
            _createVNode(_component_vxe_column, {
              field: "salesOrgCode",
              title: "销售机构编码",
              width: "120"
            }),
            _createVNode(_component_vxe_column, {
              field: "salesOrgName",
              title: "销售机构名称",
              width: "150"
            }),
            _createVNode(_component_vxe_column, {
              field: "invoiceInfoCode",
              title: "开票信息编码",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.getInvoiceInfoText(row, 'code')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "invoiceTitle",
              title: "开票信息抬头",
              width: "200"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.getInvoiceInfoText(row, 'invoiceTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "totalAmount",
              title: "开票总额",
              width: "120",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getAmountClass(row.totalAmount))
                }, _toDisplayString(_ctx.formatAmount(row.totalAmount)), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "invoicedAmount",
              title: "已开票金额",
              width: "120",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getAmountClass(row.invoicedAmount))
                }, _toDisplayString(_ctx.formatAmount(row.invoicedAmount)), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "remainAmount",
              title: "剩余可开金额",
              width: "120",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getAmountClass(row.remainAmount))
                }, _toDisplayString(_ctx.formatAmount(row.remainAmount)), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "status",
              title: "开票状态",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_OioTag, {
                  color: _ctx.getBillStatusColor(row.status)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getBillStatusText(row.status)), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "createUserName",
              title: "创建人",
              width: "100"
            }),
            _createVNode(_component_vxe_column, {
              field: "createDate",
              title: "创建时间",
              width: "160"
            }),
            _createVNode(_component_vxe_column, {
              title: "操作",
              width: "220",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.handleDetail(row))
                  }, "详情", 8, _hoisted_8),
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.handleRefreshStatus(row))
                  }, "刷新发票状态", 8, _hoisted_9),
                  (_ctx.canDownloadInvoice(row.status))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.handleDownload(row))
                      }, "下载发票", 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "loading"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_OioPagination, {
          currentPage: _ctx.pagination.current,
          pageSize: _ctx.pagination.pageSize,
          total: _ctx.pagination.total,
          showTotal: "",
          showJumper: "",
          onChange: _ctx.handlePaginationChange
        }, null, 8, ["currentPage", "pageSize", "total", "onChange"])
      ])
    ]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer billing-detail-drawer",
      visible: _ctx.detailVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detailVisible) = $event)),
      title: "独立开票包详情",
      width: 1400,
      placement: "right",
      "destroy-on-close": true,
      onClose: _ctx.handleDetailClose
    }, {
      default: _withCtx(() => [
        (_ctx.detailVisible)
          ? (_openBlock(), _createBlock(_component_BillingBillDetailPage, {
              key: 0,
              "bill-id": _ctx.detailBillId,
              mode: "view",
              independent: true
            }, null, 8, ["bill-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer billing-detail-drawer",
      visible: _ctx.createVisible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.createVisible) = $event)),
      title: "新增独立开票",
      width: 1400,
      placement: "right",
      "destroy-on-close": true
    }, {
      default: _withCtx(() => [
        (_ctx.createVisible)
          ? (_openBlock(), _createBlock(_component_IndependentBillingCreatePage, {
              key: 0,
              onSuccess: _ctx.handleCreateSuccess,
              onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.createVisible = false))
            }, null, 8, ["onSuccess"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}